// 包场订单创建
export default {
    // 列表
    table_title: "Item Order List",
    tl_projName: "Project Name",
    tl_space: "Field",
    tl_price: "Price",
    tl_date: "Date",
    tl_timeRange: "Time",
    tl_number: "Number",
    tl_amount: "Subtotal",
    statistical_desc: "Total ticket order:",

    // 新增包场
    dl_title1: "Add a private venue",
    dl_title2: "Edit Private Farm",
    dl_projName: "Project Name",
    dp_projName: "project",
    dl_space: "Field",
    dp_space: "Pick a space",
    dl_date: "Date",
    dp_date: "Pick a date",
    dl_price: "Total Price",
    dl_startTime: "Start Time",
    dp_startTime: "Pick a start time",
    dl_endTime: "End Time",
    dp_endTime: "Pick an end time",
    dl_orderNum: "Number",
    dl_operator: "Operation",
    btn_addItem: "Add Order",
    btn_editItem: "Edit Order",

    em_number: "Number cannot be empty",
    em_startTime: "Please select a start time",
    em_endTime: "Please select an end time",
    em_isSave:
        "Data of the same time already exists, please do not repeat the operation",

    sm_addItem: "Added successfully",
    sm_editItem: "Edit successfully",
    sm_cancelUse: "Cancel use successfully"
};
